import React from 'react';
import { useI18n } from './i18n';

// "How to read the Mercadini chart": collapsible guide shown under the chart (pairing form and pairing detail).
// `groups` = PAIR_GROUPS of PairingForm (food/wine pairs grouped by function): the lists of the guide are built from it,
// so the guide always matches the pairs used by the calculation.
function ChartGuide({ groups = [] }) {
  const { t } = useI18n();
  const pairText = (pair) => `${t(`pairing.p.${pair.food}`)} ↔ ${t(`pairing.p.${pair.wine}`)}`;
  const listOf = (kind) => groups.filter((group) => group.kind === kind).flatMap((group) => group.pairs).map(pairText);
  const contrast = listOf('contrast');
  const concordance = listOf('concordance');
  return (
    <details className="chart-guide">
      <summary>{t('pairing.guide.title')}</summary>
      <div className="chart-guide-body">
        <p>{t('pairing.guide.intro')}</p>

        <h4>{t('pairing.guide.read_title')}</h4>
        <ul>
          <li>{t('pairing.guide.food')}</li>
          <li>{t('pairing.guide.wine')}</li>
          <li>{t('pairing.guide.scale')}</li>
          <li>{t('pairing.guide.group')}</li>
          <li>{t('pairing.guide.hover')}</li>
          <li>{t('pairing.guide.unfilled')}</li>
        </ul>

        <h4>{t('pairing.guide.balance_title')}</h4>
        <p>{t('pairing.guide.balance')}</p>
        <p className="chart-guide-kind"><strong>{t('pairing.guide.contrast_title')}</strong> {t('pairing.guide.contrast')}</p>
        <ul className="chart-guide-pairs">{contrast.map((text) => <li key={text}>{text}</li>)}</ul>
        <p className="chart-guide-kind"><strong>{t('pairing.guide.concord_title')}</strong> {t('pairing.guide.concord')}</p>
        <ul className="chart-guide-pairs">{concordance.map((text) => <li key={text}>{text}</li>)}</ul>

        <h4>{t('pairing.guide.method_title')}</h4>
        <p>{t('pairing.guide.method')}</p>

        <h4>{t('pairing.guide.result_title')}</h4>
        <p>{t('pairing.guide.result')}</p>
        <ul>
          <li>{t('pairing.guide.band_harmonious')}</li>
          <li>{t('pairing.guide.band_fairly')}</li>
          <li>{t('pairing.guide.band_slightly')}</li>
          <li>{t('pairing.guide.band_dis')}</li>
        </ul>
        <p>{t('pairing.guide.minimum')}</p>
        <p className="chart-guide-note">{t('pairing.guide.source')}</p>
      </div>
    </details>
  );
}

export default ChartGuide;
